import {
    Button,
    Form,
    Input,
    Row,
    Col,
    Select,
    Switch,
    Tag,
    Checkbox,
    Tooltip,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import UserManagementService from '../../../services/UserManagement.service';
import DataInventoryService from '../../../services/DataInventory.service';
import ModalFail from '../../../components/Shared/modal/fail';
import ModalSuccess from '../../../components/Shared/modal/success';
import { useEffect, useState } from 'react';
import IconBack from '../../../assets/Images/icons/icon-back';
import UserService from '../../../services/UserService';
import IconEmptyDomain from '../../../assets/Images/icons/empty-domain';
import MyCompanyService from '../../../services/MyCompany.service';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import parse from 'html-react-parser';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

const AddUserPage = () => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const [form] = Form.useForm();
    const notify = useNotify();
    let { id } = useParams();
    //const history = useHistory();
    const navigate = useNavigate();
    const history = useLocation();

    const historyName = history.pathname;
    const userIdView = historyName.replace(
        '/user-management/user-list/view-user/',
        ''
    );
    const userIdEdit = historyName.replace(
        '/user-management/user-list/edit-user/',
        ''
    );
    const [loading, setLoading] = useState(0);
    const [loadinSave, setLoadinSave] = useState(false);
    const [roleUser, setRoleUser] = useState([]);
    const [permissionUser, setPermissionUser] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [openModalStatus, setOpenModalStatus] = useState(undefined);
    const [userStatus, setStatusUser] = useState(false);
    const [tagUserStatus, setTagUserStatus] = useState('WAITING');
    const [userId, setUserId] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [permissionId, setPermissionId] = useState('');
    const [domainList, setDomainList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [checkAll, setCheckAll] = useState(false);
    const [companyName, setCompanyName] = useState('');

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const getUserDetail = async (value) => {
        try {
            const { data } = await UserManagementService.getUserDetail(value);
            if (data?.resultData) {
                setStatusUser(data?.resultData.userStatus);
                setTagUserStatus(data?.resultData.userStatusName);
                setUserId(data?.resultData.userId);
                setRoleId(data?.resultData.roleId);
                getRoleUser(data?.resultData.roleId);
                getPermissionUser(data?.resultData.roleId);
                setCompanyName(data?.resultData.companyName);
                if (data?.resultData?.companyId) {
                    getDomainList(data?.resultData?.companyId);
                }
                await setField(data?.resultData);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const setField = async (resultData) => {
        if (resultData?.domainId?.length) {
            let ObjectSearch = {};
            ObjectSearch = {
                companyId: resultData?.companyId,
                p: 1,
                ps: 10000,
                s: 'domainName',
                sd: 'DESC',
            };
            try {
                const { data } = await MyCompanyService.getDomainList(
                    ObjectSearch
                );
                const item = data?.resultData;
                if (item?.result?.length === resultData?.domainId?.length) {
                    setCheckAll(true);
                }
            } catch (err) {
                console.log(err);
            }
        }
        form.setFieldsValue({
            ...resultData,
            userId: resultData.userId,
            firstName: resultData.fname,
            lastName: resultData.lname,
        });
    };
    const getRoleUser = (roleId) => {
        UserManagementService.getRoleUser().then((res) => {
            if (res.data?.resultData)
                if (
                    historyName.includes('/view-user') ||
                    roleId === 'ebf0bfbb0fd74b43975472b0820a62a6'
                ) {
                    setRoleUser(res.data?.resultData);
                } else {
                    setRoleUser(
                        res.data?.resultData?.filter(
                            (r) => r.id !== 'ebf0bfbb0fd74b43975472b0820a62a6'
                        )
                    );
                }
        });
    };
    const getPermissionUser = (roleId) => {
        UserManagementService.getPermissionUser().then((res) => {
            if (res.data?.resultData)
                if (roleId === 'ebf0bfbb0fd74b43975472b0820a62a6') {
                    setPermissionUser(res.data?.resultData);
                } else {
                    setPermissionUser(
                        res.data?.resultData?.filter(
                            (r) =>
                                r.organizePermissionName !==
                                'Super Admin (Default)'
                        )
                    );
                }
        });
    };
    const getDepartmentList = () => {
        DataInventoryService.getDepartmentList().then((res) => {
            setDepartmentList(res?.data?.resultData || []);
        });
    };

    const getCompanyList = () => {
        DataInventoryService.getCompanyList().then((res) => {
            setCompanyList(res?.data?.resultData || []);
        });
    };

    const onFinish = (value) => {
        setLoadinSave(true);
        const payload = {
            ...value,
            companyName: companyName,
            userStatus,
        };
        if (historyName.includes('/add-user')) {
            UserManagementService.saveUserDetail(payload)
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                    setLoadinSave(false);
                })
                .catch((err) => {
                    // setOpenModalStatus(false);
                    const code = err?.data?.errorData?.code;
                    if (code === 410 || code === 409) {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('userManagement.EmailIsDupplicate'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    } else {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('userManagement.FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    }
                    setLoadinSave(false);
                });
        } else if (historyName.includes('/edit-user')) {
            UserManagementService.editUserDetail({
                ...payload,
                userId,
            })
                .then((res) => {
                    if (res.data.resultMsg === 'SUCCESS') {
                        setOpenModalStatus(true);
                    } else {
                        setOpenModalStatus(false);
                    }
                    setLoadinSave(false);
                })
                .catch((err) => {
                    // setOpenModalStatus(false);
                    setLoadinSave(false);
                    const code = err?.data?.errorData?.code;
                    if (code === 410 || code === 409) {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('userManagement.EmailIsDupplicate'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    } else {
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('userManagement.FailedtoSubmitData'),
                            closeable: true,
                            timeOut: 120000,
                        });
                    }
                });
        }
    };

    const role = UserService.role()?.toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    useEffect(() => {
        if (!admin) {
            navigate(`/not-found`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admin]);

    useEffect(() => {
        if (loading === 0) {
            if (historyName.includes('/view-user')) {
                getUserDetail(id);
            } else if (historyName.includes('/edit-user')) {
                if (admin) {
                    getUserDetail(id);
                } else {
                    navigate(
                        `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                    );
                }
            } else {
                form.resetFields();
                getRoleUser();
                getPermissionUser();
            }

            getDepartmentList();
            getCompanyList();
        }
        setLoading(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        admin,
        form,
        getUserDetail,
        historyName,
        loading,
        navigate,
        userIdEdit,
        userIdView,
    ]);

    const onCheckAllChange = (e) => {
        if (e.target.checked) {
            setCheckAll(true);
            form.setFieldsValue({
                domainId: domainList.map((e) => e.domainId),
            });
        } else {
            setCheckAll(false);
            form.setFieldsValue({ domainId: [] });
        }
    };

    const onCompanyChange = (value) => {
        const item = companyList.find((res) => res.id === value)?.companyName;
        getDomainList(value);
        setCheckAll(false);
        setCompanyName(item);
        form.setFieldsValue({ domainId: [] });
    };

    const getDomainList = async (companyId) => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: companyId,
            p: 1,
            ps: 10000,
            s: 'domainName',
            sd: 'ASC',
        };
        try {
            const { data } = await MyCompanyService.getDomainList(ObjectSearch);
            const item = data?.resultData;
            setDomainList(item?.result);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div className="bg-gray-body ">
            {/* <HeaderLayout /> */}

            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() =>
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                        )
                    }
                >
                    <IconBack />
                </div>
                {historyName.includes('/view-user')
                    ? t('userManagement.UserDetails')
                    : historyName.includes('/edit-user')
                    ? t('userManagement.EditUser')
                    : t('Add User')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('common.Configuration')} / {t('User Management')} /{' '}
                    {t('User List')} /
                </span>
                <span>
                    {' '}
                    {historyName.includes('/view-user')
                        ? t('userManagement.UserDetails')
                        : historyName.includes('/edit-user')
                        ? t('userManagement.EditUser')
                        : t('Add User')}
                </span>
            </div>
            <div className="w-full m-auto">
                {/* <div className="text-xl py-12 px-4">
                    {t('landing.Please Select Activities below to')}
                    <strong> {t('landing.Begin Your Process')}</strong>
                </div> */}

                {/* <div className="container h-full mx-auto p-8 px-5 "> */}

                <div
                    className="content bg-white p-8 mt-6"
                    style={{ borderRadius: '6px' }}
                >
                    <div className="content pb-3">
                        <Form
                            scrollToFirstError={{
                                behavior: 'smooth',
                                block: 'center',
                            }}
                            onFinish={onFinish}
                            form={form}
                            className="w-full"
                            layout="vertical"
                            onValuesChange={(all, b) => {
                                if (b.domainId?.length === domainList?.length) {
                                    setCheckAll(true);
                                }
                            }}
                        >
                            <Row
                                style={{
                                    borderBottom: '1px solid #F4F6FC',
                                    marginBottom: 20,
                                }}
                            >
                                <Col span={12} style={{ marginBottom: 20 }}>
                                    <div>
                                        <Row>
                                            <div
                                                className="title"
                                                style={{ color: '#7B67FB' }}
                                            >
                                                {t(
                                                    'userManagement.UserInformation'
                                                )}
                                            </div>
                                        </Row>
                                    </div>
                                </Col>
                                {historyName.includes('/view-user') ===
                                true ? null : (
                                    <Col span={12} className="w-full">
                                        <Row>
                                            <Col span={24} className="w-full">
                                                <Row
                                                    style={{
                                                        position: 'absolute',
                                                        right: 0,
                                                    }}
                                                >
                                                    <Button
                                                        size="large"
                                                        htmlType="reset"
                                                        type="default"
                                                        className="text-purple-PHX border-purple-PHX w-full"
                                                        onClick={() =>
                                                            navigate(
                                                                `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                                                            )
                                                        }
                                                        //className="text-purple-PHX border-purple-PHX w-full"
                                                        style={{
                                                            width: 120,
                                                            marginRight: 20,
                                                        }}
                                                    >
                                                        {t('Cancel')}
                                                    </Button>
                                                    <Button
                                                        loading={loadinSave}
                                                        size="large"
                                                        htmlType="submit"
                                                        type="primary"
                                                        className="w-full"
                                                        style={{ width: 120 }}
                                                    >
                                                        {t('Save')}
                                                    </Button>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Col>
                                )}
                            </Row>

                            <div className="grid grid-cols-3 gap-10">
                                <div className="p-1">
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('First name')}
                                            </span>
                                        }
                                        name="firstName"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.FirstNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('First name')}
                                            showCount
                                            maxLength={20}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Phone Number')}
                                            </span>
                                        }
                                        name="phone"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.PhoneNumberIsrequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Phone Number')}
                                            showCount
                                            maxLength={15}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Staff ID')}
                                            </span>
                                        }
                                        name="staffId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.StaffIDIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Staff ID')}
                                            showCount
                                            maxLength={20}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        />
                                    </Form.Item>
                                    <div className="flex justify-between w-full items-center pb-2">
                                        <span className="font-semibold">
                                            {t('Role')}
                                        </span>
                                        <Tooltip
                                            placement="right"
                                            overlayClassName="min-w-[300px]"
                                            title={parse(
                                                t('userManagement.Role tooltip')
                                            )}
                                        >
                                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                                <ExclamationCircleOutlined />
                                            </a>
                                        </Tooltip>
                                    </div>
                                    <Form.Item
                                        label={false}
                                        name="roleId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.RoleIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t('Role')}
                                            onChange={(value) => {
                                                setRoleId(value);
                                            }}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : '' ||
                                                      roleId ===
                                                          'ebf0bfbb0fd74b43975472b0820a62a6'
                                            }
                                        >
                                            {roleUser.map((role) => (
                                                <Option
                                                    size="large"
                                                    key={role.id}
                                                    value={role.id}
                                                    hidden={
                                                        role.id ===
                                                        'ebf0bfbb0fd74b43975472b0820a62a6'
                                                    }
                                                >
                                                    {role.role}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <div className="flex justify-between w-full items-center pb-2">
                                        <span className="font-semibold">
                                            {t('userManagement.Permission')}
                                        </span>
                                        <Tooltip
                                            placement="right"
                                            overlayClassName="min-w-[300px]"
                                            title={parse(
                                                t(
                                                    'userManagement.Permission tooltip'
                                                )
                                            )}
                                        >
                                            <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                                                <ExclamationCircleOutlined />
                                            </a>
                                        </Tooltip>
                                    </div>
                                    <Form.Item
                                        label={false}
                                        name="organizePermissionId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.PermissionIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t(
                                                'userManagement.Permission'
                                            )}
                                            onChange={(value) => {
                                                setPermissionId(value);
                                            }}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : '' ||
                                                      roleId ===
                                                          'ebf0bfbb0fd74b43975472b0820a62a6'
                                            }
                                        >
                                            {permissionUser.map(
                                                (permission) => (
                                                    <Option
                                                        size="large"
                                                        key={
                                                            permission.organizePermissionId
                                                        }
                                                        value={
                                                            permission.organizePermissionId
                                                        }
                                                    >
                                                        {
                                                            permission.organizePermissionName
                                                        }
                                                    </Option>
                                                )
                                            )}
                                        </Select>
                                    </Form.Item>
                                </div>
                                <div className="p-1">
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Last name')}
                                            </span>
                                        }
                                        name="lastName"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.LastNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Last name')}
                                            showCount
                                            maxLength={20}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Email')}
                                            </span>
                                        }
                                        name="email"
                                        colon={false}
                                        rules={[
                                            {
                                                type: 'email',
                                                message: t(
                                                    'MyCompany.EmailNotValid'
                                                ),
                                            },
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.EmailIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Input
                                            size="large"
                                            placeholder={t('Email')}
                                            showCount
                                            maxLength={50}
                                            disabled={
                                                historyName.includes(
                                                    '/add-user'
                                                )
                                                    ? false
                                                    : true
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Department')}
                                            </span>
                                        }
                                        className="initial"
                                        name="departmentId"
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.DepartmentIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t('Department')}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                            showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                (option?.children ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase()
                                                    )
                                            }
                                        >
                                            {departmentList.map((list) => (
                                                <Option
                                                    size="large"
                                                    key={list.departmentId}
                                                    value={list.departmentId}
                                                >
                                                    {list.nameEn}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    <Form.Item
                                        label={
                                            <span className="font-semibold">
                                                {t('Company Name')}
                                            </span>
                                        }
                                        name="companyId"
                                        colon={false}
                                        rules={[
                                            {
                                                required: true,
                                                message: t(
                                                    'userManagement.CompanyNameIsRequired'
                                                ),
                                            },
                                        ]}
                                    >
                                        <Select
                                            size="large"
                                            style={{ textAlign: 'left' }}
                                            placeholder={t('Company Name')}
                                            onChange={onCompanyChange}
                                            disabled={
                                                historyName.includes(
                                                    '/view-user'
                                                )
                                                    ? 'disabled'
                                                    : ''
                                            }
                                        >
                                            {companyList?.map((e) => (
                                                <Option
                                                    size="large"
                                                    key={e.id}
                                                    value={e.id}
                                                >
                                                    {e.companyName}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                    {roleId !==
                                        'ebf0bfbb0fd74b43975472b0820a62a6' && (
                                        <Form.Item
                                            label={
                                                <span className="font-semibold">
                                                    {t('User Status')}
                                                </span>
                                            }
                                        >
                                            <span className="mr-2">
                                                {t(
                                                    'userManagement.ActivationStatus'
                                                )}
                                            </span>
                                            <Switch
                                                checked={userStatus}
                                                size="large"
                                                onChange={(value) => {
                                                    setStatusUser(value);
                                                    setTagUserStatus(
                                                        value
                                                            ? 'ACTIVE'
                                                            : 'INACTIVE'
                                                    );
                                                }}
                                                disabled={
                                                    historyName.includes(
                                                        '/view-user'
                                                    ) ||
                                                    tagUserStatus === 'WAITING'
                                                        ? 'disabled'
                                                        : ''
                                                }
                                            />
                                            <p className="mr-2">
                                                {tagUserStatus ===
                                                    'WAITING' && (
                                                    <Tag className="rounded-xl -my-1 text-center bg-[#F9C153] border-[#F9C153] text-white">
                                                        {t(
                                                            'Waiting for active'
                                                        )}
                                                    </Tag>
                                                )}
                                                {tagUserStatus === 'ACTIVE' && (
                                                    <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white">
                                                        {t('Active')}
                                                    </Tag>
                                                )}
                                                {tagUserStatus ===
                                                    'INACTIVE' && (
                                                    <Tag className="rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white">
                                                        {t('InActive')}
                                                    </Tag>
                                                )}
                                            </p>
                                        </Form.Item>
                                    )}
                                </div>
                                <div hidden className="pl-10 pr-10">
                                    <div
                                        className="rounded-md py-4 pl-4 pr-2 mb-4 inline-grid w-full bg-white"
                                        style={{ border: '1px solid #DBDBDB' }}
                                    >
                                        <div className="px-2">
                                            <div className="font-semibold text-[16px] mb-2">
                                                {t(
                                                    'userManagement.ConfigurePermissions'
                                                )}
                                            </div>
                                            <div className="font-base text-[12px] text-[#B7B7C0] mb-2">
                                                ({t('userManagement.Optional')})
                                            </div>
                                            <div className="font-base text-[12px] text-[#65707A] mb-1 whitespace-pre-line">
                                                {t(
                                                    'userManagement.SpecifyCustomize'
                                                )}
                                            </div>
                                        </div>

                                        <div className="px-2 overflow-auto h-96 mt-2">
                                            {domainList?.length > 0 ? (
                                                <>
                                                    <Checkbox
                                                        value={'checkAll'}
                                                        style={{
                                                            lineHeight: '32px',
                                                        }}
                                                        onChange={
                                                            onCheckAllChange
                                                        }
                                                        checked={checkAll}
                                                        disabled={
                                                            historyName.includes(
                                                                '/view-user'
                                                            )
                                                                ? 'disabled'
                                                                : ''
                                                        }
                                                    >
                                                        {lang === 'en'
                                                            ? 'Select All'
                                                            : 'เลือกทั้งหมด'}
                                                    </Checkbox>
                                                    <Form.Item
                                                        name={'domainId'}
                                                    >
                                                        <Checkbox.Group className="w-full">
                                                            {domainList?.map(
                                                                (is) => {
                                                                    return (
                                                                        <div
                                                                            key={
                                                                                is.domainId
                                                                            }
                                                                        >
                                                                            <Checkbox
                                                                                key={
                                                                                    is.domainId
                                                                                }
                                                                                value={
                                                                                    is.domainId
                                                                                }
                                                                                style={{
                                                                                    lineHeight:
                                                                                        '32px',
                                                                                }}
                                                                                onChange={(
                                                                                    e
                                                                                ) =>
                                                                                    setCheckAll(
                                                                                        false
                                                                                    )
                                                                                }
                                                                                disabled={
                                                                                    historyName.includes(
                                                                                        '/view-user'
                                                                                    )
                                                                                        ? 'disabled'
                                                                                        : ''
                                                                                }
                                                                            >
                                                                                {lang ===
                                                                                'en'
                                                                                    ? is.domainName
                                                                                    : is.domainName}
                                                                            </Checkbox>
                                                                            <br />
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </Checkbox.Group>
                                                    </Form.Item>
                                                </>
                                            ) : (
                                                <div className="h-[40vh] flex justify-center items-center">
                                                    <IconEmptyDomain />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
            {openModalStatus && (
                <ModalSuccess
                    open={openModalStatus}
                    handelClose={() => {
                        setOpenModalStatus(undefined);
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                        );
                    }}
                    handelOk={() => {
                        setOpenModalStatus(undefined);
                        navigate(
                            `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`
                        );
                    }}
                    text={t('Successfully saved data')}
                />
            )}
            <ModalFail
                open={openModalStatus === false}
                handelClose={() => {
                    setOpenModalStatus(undefined);
                }}
                handelOk={() => {
                    setOpenModalStatus(undefined);
                }}
                text={t('Failed to submit data')}
            />
        </div>
    );
};

export default AddUserPage;
